var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardPayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.14752 1.7973C3.20242 0.646508 4.63316 0 6.125 0H29.875C31.3668 0 32.7976 0.646508 33.8525 1.7973C34.9074 2.94809 35.5 4.5089 35.5 6.13636V8.18182H0.5V6.13636C0.5 4.5089 1.09263 2.94809 2.14752 1.7973ZM0.5 12V23.8636C0.5 25.4911 1.09263 27.0519 2.14752 28.2027C3.20242 29.3535 4.63316 30 6.125 30H29.875C31.3668 30 32.7976 29.3535 33.8525 28.2027C34.9074 27.0519 35.5 25.4911 35.5 23.8636V12H0.5ZM25 19C23.8954 19 23 19.8954 23 21C23 22.1046 23.8954 23 25 23H30C31.1046 23 32 22.1046 32 21C32 19.8954 31.1046 19 30 19H25Z",
    fill: "#F46350"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPayIcon);
export default __webpack_public_path__ + "static/media/CardPayIcon.ad4238ee202da0f530b1c6d708530ab3.svg";
export { ForwardRef as ReactComponent };